<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <transition name="view" appear enter-active-class="animated fadeIn delay">
                    <div class="card card-plain">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-5 col-lg-3"><h1 class="title">Projects Overview</h1></div>
                                <div class="col-md-7 col-lg-9">
                                    <selector :data="projects" :currentValue="current" @change="openProject"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <transition v-if="!dataShown" name="view"  leave-active-class="animated fadeOut">
                    <blockquote class="blockquote text-center">
                        <img style="max-height: 250px" src="img/logo.png">
                        <h2><p class="mb-0">ELEGANCE NEVER GOES OUT OF STYLE</p></h2>
                        <footer class="blockquote-footer">ELEGANT ENTERPRISES INC. <cite title="Source Title">ALL RIGHTS RESERVED</cite></footer>
                    </blockquote>
                </transition>
            </div>
        </div>
        <div class="row">
            <transition v-if="dataShown" name="view" appear enter-active-class="animated fadeIn delay">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12"><h2>Project: <code class="text-center text-warning">{{projectName}}</code></h2></div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="row">
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openProjectSettings">
                                        <div class="font-icon-detail">
                                            <h3 style=" margin-top: 0;"><i class="tim-icons icon-settings-gear-63"></i>
                                                <p>Project settings</p></h3>
                                        </div>
                                    </div>
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openProjectDocuments">
                                        <div class="font-icon-detail">
                                            <h3><i class="tim-icons icon-single-copy-04"></i>
                                                <p>Project documents</p></h3>
                                        </div>
                                    </div>
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openIncomes">
                                        <div class="font-icon-detail">
                                            <h3><i class="tim-icons icon-pencil"></i>
                                                <p>Incomes Expenses</p></h3>
                                        </div>
                                    </div>
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openReports">
                                        <div class="font-icon-detail">
                                            <h3 style=" margin-top: 0;"><i class="tim-icons icon-chart-bar-32"></i>
                                                <p>Budget report</p></h3>
                                        </div>
                                    </div>
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openEmployeesReports">
                                        <div class="font-icon-detail">
                                            <h3><i class="tim-icons icon-single-02"></i>
                                                <p>Employees Report</p></h3>
                                        </div>
                                    </div>
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openInventorization">
                                        <div class="font-icon-detail">
                                            <h3 style=" margin-top: 0;"><i class="tim-icons icon-trophy"></i>
                                                <p>Inventory</p></h3>
                                        </div>
                                    </div>
                                    <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6" @click="openArticlesSettings">
                                        <div class="font-icon-detail">
                                            <h3 style=" margin-top: 0;"><i class="tim-icons icon-components"></i>
                                                <p>Columns Settings</p></h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
import ProjectsFilter from "../components/Filters/Projects";
import ProgressBar from "../components/Progress";
import axios from "axios";
import {setCookie, url} from "../plugins/axios";
import NotificationTemplate from "./Notifications/NotificationTemplate";
import Selector from "@/components/Selector";
export default {
    name: "Projects",
    components: {Selector, ProjectsFilter, ProgressBar},
    data(){
        return{
            progressValue: 0,
            projects: [],
            current: 0,
            projectName: '',
            dataShown:false,
        }
    },
    methods:{
        notifyVue(type,message) {
            this.$notify({
                component: NotificationTemplate,
                icon: "tim-icons icon-bell-55",
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: type,
                message:message,
                timeout: 1500
            });
        },
        getProjectForFilter(){
            axios
                .get(url + 'projects-short/',
                    {
                        withCredentials:'include',
                        crossDomain:true
                    })
                .then((response) => {
                    if (response.data.error === ''){
                        this.projects = response.data.result
                    }
                    else{
                        if (response.data.error === 'Session is over'){
                            setCookie('Authentication','Failed',1);
                            this.$router.push('/login');
                        }
                        else{
                            this.notifyVue('danger',response.data.error);
                        }
                    }
                })
                .catch((error) => {
                    this.notifyVue('danger',error);
                });

        },
        openProject(id){
            this.dataShown = false;
            if (id > 0){
                this.getNameProject(id);
                let urlParam = '#/projects/?projectId=' + id;
                this.current = id;
                urlParam += '&projectName=' + this.projectName.split(' ').join('_');
                window.history.pushState("", "", urlParam);
                setTimeout(()=>{this.dataShown = true;},1000);
            }
            else{
                this.$router.push('/projects-settings/?projectId=0')
            }
        },
        openProjectSettings(){
            let urlParam = '/projects-settings/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            this.$router.push(urlParam)
        },
        openProjectDocuments(){
            let urlParam = '/projects-documents/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            this.$router.push(urlParam);
        },
        openIncomes(){
            let urlParam = '/projects-incomes-expenses/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            this.$router.push(urlParam);
        },
        openReports(){
            let urlParam = '/projects-reports/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            this.$router.push(urlParam);
        },
        openEmployeesReports(){
            let urlParam = '/employees-reports/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            this.$router.push(urlParam);
        },
        openInventorization(){
            let urlParam = '/inventory/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            this.$router.push(urlParam);
        },
        getNameProject(id){
            for (let project in this.projects){
                if (parseInt(id) === parseInt(this.projects[project].project_id)){
                    this.projectName = this.projects[project].full_name;
                }
            }
        },
        openArticlesSettings(){
            let urlParam = '/incomes-expenses-settings/?projectId=' + this.current;
            urlParam += '&projectName=' + this.projectName.split(' ').join('_');
            //this.$router.push('/page-not-found');
            this.$router.push(urlParam);
        },
        getProjectStyle(condition){
            if (condition)
                return {
                    'font-size': '20px!important',
                    'color': '#ff8d72!important'
                }
            else return {}
        },
    },
    created() {
        this.getProjectForFilter();
        const params = this.$route.query;
        if (params.projectName){
            this.projectName = params.projectName.split('_').join(' ');
        }
        if (params.projectId > 0){
            this.current = params.projectId;
            this.dataShown = true;
            this.openProject(this.current)
        }
    }
}
</script>

<style scoped>
.font-icon-list{
    cursor:pointer;
}
h3{
    margin-bottom: -30px;
}
.delay{
    animation-delay: 1.0s;
}
</style>
<style>
.project-active{
    font-size: 20px!important;
    color: #ff8d72!important;
}
</style>
